import { render, staticRenderFns } from "./TextTopic.vue?vue&type=template&id=71dece33&scoped=true"
import script from "./TextTopic.vue?vue&type=script&lang=js"
export * from "./TextTopic.vue?vue&type=script&lang=js"
import style0 from "./TextTopic.vue?vue&type=style&index=0&id=71dece33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dece33",
  null
  
)

export default component.exports